import { useEffect } from 'react';
import { usePlayer } from '../contexts/PlayerContext';

const Shortcuts: React.FC = () => {
  const { isPlaying, pauseSong, resumeSong, nextSong, previousSong } = usePlayer();

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Não executar se estiver digitando em um input
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      switch (e.code) {
        case 'Space':
          e.preventDefault();
          if (isPlaying) {
            pauseSong();
          } else {
            resumeSong();
          }
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextSong();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          previousSong();
          break;
        case 'ArrowUp':
        case 'ArrowDown':
          e.preventDefault();
          // Volume será controlado pelo player
          break;
        case 'KeyL':
          // Letra será controlada pelo LyricsViewer
          break;
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [isPlaying, pauseSong, resumeSong, nextSong, previousSong]);

  return null;
};

export default Shortcuts;